<template>
  <header class="header">
    <div class="logo">
      <router-link to="/" class="logo-link"><img src="/images/logo.png" alt="北京西宝电子技术有限责任公司"></router-link>
    </div>
    <span class="menuBtn" >
    </span>
    <div class="hdr" >
      <div class="nav">
        <ul>
          <li class="i1 mouseenter mouseleave" :class="{on: isActive('/')}" >
            <router-link to="/" class="v1"  >首页</router-link>
          </li>
          <li class="i2 mouseenter mouseleave"  :class="{on: isAboutActive}">
            <router-link to="/about" class="v1" >关于我们</router-link>
            <div class="sub sub-1">
              <dl>
                <dd>
                  <router-link to="/about#company"  >公司简介</router-link>
                </dd>
                <dd>
                  <router-link to="/about#honors"  >公司荣誉</router-link>
                </dd>
                <!-- <dd>
                  <router-link to="/about#jobs"  >人才招聘</router-link>
                </dd> -->
              </dl>
            </div>
          </li>
          <li class="i3 mouseenter mouseleave" :class="{on: isProductActive}" >
            <router-link to="/product-center?id=308" class="v1"  >产品中心</router-link>
        
          </li>
            <li class="i3 mouseenter mouseleave" :class="{on: isAppActive}" >
            <router-link to="/app-center" class="v1"  >应用中心</router-link>
        
          </li>
          <li class="i4 mouseenter mouseleave" :class="{on: isNewsActive}" >
            <router-link to="/news" class="v1"  >新闻资讯</router-link>
            <div class="sub sub-1">
              <dl>
                <!-- <dd>
                  <router-link to="/news?#industry">行业动态</router-link>
                </dd> -->
                <dd>
                  <router-link to="/news#company"  >公司新闻</router-link>
                </dd>
                <dd>
                  <router-link to="/news#new-product"  >最新产品</router-link>
                </dd>
              </dl>
            </div>
          </li>
          <!-- <li class="i5 mouseenter mouseleave" :class="{on: isResourceActive}" >
            <router-link to="/resource-center" class="v1"  >资源中心</router-link>
            <div class="sub sub-1">
              <dl>
                <dd>
                  <router-link to="/resource-center#docs"  >技术文档</router-link>
                </dd>
                <dd>
                  <router-link to="/resource-center#specifications"  >产品说明</router-link>
                </dd>
                <dd>
                  <router-link to="/resource-center#manuals"  >产品手册</router-link>
                </dd>
              </dl>
            </div>
          </li> -->
        </ul>
      </div>
      <div class="so">
        <form @submit.prevent="performSearch">
          <input type="text" placeholder="请输入搜索内容" class="inp" v-model="searchKeyword">
          <button class="btn" @click.prevent="performSearch"></button>
        </form>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
      searchKeyword: '',
      activeCategory: 14, // 默认选中波导器件
      mobileMenuOpen: false,
      isMobile: false
    }
  },
  computed: {
    isAboutActive() {
      const path = this.$route ? this.$route.path : window.location.pathname;
      return path.startsWith('/about');
    },
    isProductActive() {
      const path = this.$route ? this.$route.path : window.location.pathname;
      return path.startsWith('/product-center');
    },
    isAppActive() {
      const path = this.$route ? this.$route.path : window.location.pathname;
      return path.startsWith('/app-center');
    },
    isNewsActive() {
      const path = this.$route ? this.$route.path : window.location.pathname;
      return path.startsWith('/news');
    },
    isResourceActive() {
      const path = this.$route ? this.$route.path : window.location.pathname;
      return path.startsWith('/resource') ;
    }
  },
  methods: {
    isActive(path) {
      const currentPath = this.$route ? this.$route.path : window.location.pathname;
      return currentPath === path;
    },
    isCategoryActive(catId) {
      return this.activeCategory === catId;
    },
    performSearch() {
      if (this.searchKeyword.trim()) {
        // 实现搜索功能
        // console.log('Searching for:', this.searchKeyword);
        this.$router.push({ path: '/result', query: { keyword: this.searchKeyword, t: Date.now() } });
    
        if(window.innerWidth <= 1200){
           this.closeMobileMenu();
        }
      }else{
        alert('请输入搜索内容');
      }
    },
    setActiveCategory(catId) {
      this.activeCategory = catId;
    },
  

  
  
    checkScreenSize() {
      const wasMobile = this.isMobile;
      this.isMobile = window.innerWidth <= 1199;
      
      // 只有在移动设备模式发生变化时才调整显示
      if (wasMobile !== this.isMobile && this.$refs.hdr) {
        const hdr = this.$refs.hdr;
        if (!this.isMobile) {
          // 切换到桌面模式，应用桌面样式
          hdr.style.display = 'flex';
          hdr.style.height = '';
          hdr.style.opacity = '';
          hdr.style.transform = '';
          hdr.style.transition = '';
          hdr.style.visibility = '';
          hdr.style.left = '';
          hdr.style.right = '';
          hdr.style.top = '';
          hdr.style.bottom = '';
          
          // 移除移动端菜单开启类
          hdr.classList.remove('mobile-menu-open');
          if (!this.mobileMenuOpen) {
            hdr.style.display = 'none';
          }
        } else {
          // 切换到移动模式，但保持当前菜单状态
          hdr.style.display = this.mobileMenuOpen ? 'block' : 'none';
          if (this.mobileMenuOpen) {
            hdr.classList.add('mobile-menu-open');
            hdr.style.visibility = 'visible';
          } else {
            hdr.classList.remove('mobile-menu-open');
            hdr.style.visibility = 'hidden';
          }
          hdr.style.opacity = '';
          hdr.style.transform = '';
          hdr.style.transition = '';
        }
      }
    },
    updateActiveCategory() {
      const path = this.$route ? this.$route.path : window.location.pathname;
      if (path.includes('catid=14')) this.activeCategory = 14;
      else if (path.includes('catid=17')) this.activeCategory = 17;
      else if (path.includes('catid=15')) this.activeCategory = 15;
      else if (path.includes('catid=16')) this.activeCategory = 16;
      else if (path.includes('catid=18')) this.activeCategory = 18;
      else if (path.includes('catid=19')) this.activeCategory = 19;
    },
    handleCategoryHover(catId) {
      this.activeCategory = catId;
    },
closeMobileMenu() {
  // 关闭移动端菜单，相当于lib.js中的closeMobileMenu函数
  // 关闭所有子菜单
  
  const subMenus = document.querySelectorAll('.nav .sub');
  subMenus.forEach(subMenu => {
    subMenu.style.display = 'none';
  });
  
  // 关闭hdr
  const hdr = document.querySelector('.hdr');
  if (hdr) {
    hdr.style.display = 'none';
  }
  
  // 移除menuBtn的open类
  const menuBtn = document.querySelector('.menuBtn');
  if (menuBtn) {
    menuBtn.classList.remove('open');
  }
  
  // 更新Vue组件数据
  this.mobileMenuOpen = false;
}
   
  },
  mounted() {
    // 初始化屏幕尺寸检测
    this.checkScreenSize();
    
    // 监听窗口大小变化
    window.addEventListener('resize', this.checkScreenSize);
    
    // 监听路由变化更新激活状态
    if (this.$route) {
      this.$watch('$route', () => {
        this.updateActiveCategory();
      });
    }
    this.updateActiveCategory();
  },
  beforeDestroy() {
    // 移除事件监听器
    window.removeEventListener('resize', this.checkScreenSize);
  }
}
</script>

<style>
/* 覆盖 lib.css 中 .nav .sub{display: none;} 的规则 */

</style>